import { CommandBar as FluentCommandBar, ICommandBarProps } from '@fluentui/react';
import { useClassNames } from "../../hooks/useClassNames";
import { useMemo } from "react";
import { getCommandBarStyles } from "./styles";
import { ICommandBarItemProps as ICommandBarItemPropsBase } from "@fluentui/react";


/**  
    Extends the native CommandBarItemProps interface to allow for additional functionality.
*/
export interface ICommandBarItemProps extends ICommandBarItemPropsBase {
    /**  
    Sets if the item should be visible only while hovering over the component. 
    The item will also be visible if the component is focused.
    */
    showOnlyOnHover?: boolean;
}

export const CommandBar = (props: ICommandBarProps) => {
    const commandBarStyles = useMemo(() => getCommandBarStyles(), [])
    const injectProps = (items?: ICommandBarItemProps[]) => {
        items?.map(item => {
            item.title = item.title ?? item.text;
            if(item.showOnlyOnHover) {
                item.className = item.className ? `${item.className} hover-only` : 'hover-only'
            }
        })
    }
    injectProps(props.items);
    injectProps(props.farItems);
    //replace is done for back compat - command bar did not include the __root suffix before
    //replace due to back comp with old CSS where it often targets the class name directly
    //the decision to add the properties as --propName directly to className instead of creating
    //another class was really unfortunate, we need to abandon this practice
    const classNames = useClassNames('Command-Bar', {className: props.className}).replace('__root', '').replace('--underlined', '');
    return <FluentCommandBar 
        {...props} 
        className={`${classNames} ${commandBarStyles.root}`} />
}